import { computed, type ComputedRef } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import { useInboxOrderSupportRenameFlag } from '@/features/reviews/composables/useInboxOrderSupportRenameFlag'

export const usePageDescription = (): ComputedRef<string | undefined> => {
  const route = useRoute()
  // eslint-disable-next-line @typescript-eslint/unbound-method -- false positive
  const { t, te } = useI18n()
  const renameEnabled = useInboxOrderSupportRenameFlag()

  return computed(() => {
    for (let i = route.matched.length - 1; i > 0; i--) {
      const match = route.matched[i]

      if (match?.meta?.title) {
        // Feedback → Customer support rename gated on inbox_order_support_rename
        if (match.name === 'brand.feedback' && renameEnabled.value) {
          const renamedKey =
            'core.pages.restaurant.customer-support.description'
          return te(renamedKey) ? t(renamedKey) : undefined
        }
        const key = `core.pages.${match.meta.title}.description`

        return te(key) ? t(key) : undefined
      }
    }

    return undefined
  })
}
